import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { commonService } from 'services/common.service';
import { BROKER_ENDPOINT } from 'apiEndpoints';
import ImageElement from '../../components/ImageElement';
import Button from '../../components/Button';

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    if (localStorage.getItem('authToken')) {
      navigate('/categories');
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg('');
    try {
      const response = await commonService({
        apiEndPoint: BROKER_ENDPOINT.postLoginBroker,
        bodyData: { email, password },
        toastMessage: { success: 'Login successful', error: '' },
      });

      if (response.data?.success === false && response.data?.error?.message) {
        setErrorMsg(response.data.error.message);
        return;
      }

      if (response.status && response.data?.Data?.Authorization) {
        
        localStorage.setItem('authToken', response.data.Data.Authorization);
        
        // Store user data for display
        const userData = {
          email,
          name: response.data?.Data?.name || email.split('@')[0], // Use name from response or extract from email
          ...response.data?.Data // Store any other user data from response
        };
        localStorage.setItem('userData', JSON.stringify(userData));
        
        navigate('/categories');
      }
    } catch (error) {
      try {
        const errorObj = JSON.parse(error.message);
        setErrorMsg(errorObj?.data?.message || 'Login failed');
      } catch {
        setErrorMsg('Login failed');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page d-flex justify-content-center align-items-center min-vh-100" style={{ background: '#f9f1ec' }}>
      <div className="w-100 d-flex flex-column align-items-center" style={{ maxWidth: 400 }}>
        <div className="login-logo mb-4">
          <ImageElement source="logo.svg" imageFor="user" alt="Logo" style={{ width: 90, height: 90 }} />
        </div>
        
        <form className="login-form d-flex flex-column align-items-center" style={{ minWidth: 340, maxWidth: 400 }} onSubmit={handleLogin} autoComplete="off">
          <div className="form-group w-100 mb-4">
            <label className="form-label text-uppercase" style={{ fontSize: 13, letterSpacing: 1 }}>Email</label>
            <input
              type="email"
              className="form-control border-0 border-bottom rounded-0 px-0 bg-transparent"
              style={{ fontSize: 16, background: 'transparent', borderColor: '#52403a', color: '#312622' }}
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          <div className="form-group w-100 mb-4">
            <label className="form-label text-uppercase" style={{ fontSize: 13, letterSpacing: 1 }}>Password</label>
            <input
              type="password"
              className="form-control border-0 border-bottom rounded-0 px-0 bg-transparent"
              style={{ fontSize: 16, background: 'transparent', borderColor: '#52403a', color: '#312622' }}
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          {errorMsg && (
          <div className="text-danger mb-3" style={{ fontSize: 14 }}>
            {errorMsg}
          </div>
        )}
          <Button type="submit" className="login-btn mt-2 px-4 py-2 d-flex align-items-center mx-auto bg-transparent border-0 text-uppercase" style={{ color: '#52403a', fontSize: 14, letterSpacing: 2 }} disabled={loading}>
            {loading ? 'Logging in...' : (<><span>Log In</span> <span className="icon-arrow-right ms-2" style={{ fontSize: 18 }} /></>)}
          </Button>
        </form>
        <div className="mt-4">
          <a href="#" className="text-decoration-underline" style={{ color: '#52403a', fontSize: 13 }}>Forgot Password</a>
        </div>
      </div>
    </div>
  );
}
